import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {DataService} from './data.service';
import { BehaviorSubject, from, Observable, of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MainService {

  constructor(
    private http:HttpClient,
    private dataService:DataService
  ) { }

  async submitWaiverForm(data:any){
    return await this.dataService
    .post('Waiver',data)
    .then(result=>{
      return result;
    });
  } 
}